export default __webpack_public_path__ + "static/media/sdg-logo.f0d584f9.png";